import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import * as React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../routes/types';

import { OrderHistoryMainItemComponentProps } from './constants';
import OrderHistoryItemDesktop from './desktop';
import OrderHistoryItemMobile from './mobile';
import OrderHistoryItemTablet from './tablet';

export const OrderHistoryItem = (props: OrderHistoryMainItemComponentProps) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const isReferencedByBasket =
    !!props.item.basketDetail &&
    !!props.item.basketDetail.basketAdvisorOrderId &&
    !!props.item.basketDetail.basketAdvisorOrderHash;

  const onBasketPress = () => {
    if (isReferencedByBasket) {
      navigate('BatchTicketDetail', {
        basketAdvisorOrderId: props.item.basketDetail.basketAdvisorOrderId,
      });
    }
  };

  const allProps = { ...props, isReferencedByBasket, onBasketPress };

  const responsiveTable = useBreakpointValue({
    base: <OrderHistoryItemMobile {...allProps} />,
    sm: <OrderHistoryItemTablet {...allProps} />,
    lg: <OrderHistoryItemDesktop {...allProps} />,
  });

  return responsiveTable;
};

export default React.memo(OrderHistoryItem);
